import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider
} from '@mui/material';
import VeersaLoaderGif from "../../common/icons/Veersa-loader.gif";
import WarningIcon from '@mui/icons-material/Warning';
import './ProjectEndDateConfirmationModal.css';

const ProjectEndDateConfirmationModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  originalEndDate, 
  newEndDate, 
  loading = false 
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : handleCancel}
      maxWidth="xs"
      PaperProps={{
        style: {
          borderRadius: '8px',
          padding: '4px',
          minWidth: '400px',
          maxWidth: '450px'
        }
      }}
    >
      <DialogTitle>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          gap: 1,
          textAlign: 'center',
          paddingBottom: 0
        }}>
          <Typography variant="h6" component="div" sx={{ 
            fontWeight: 'bold', 
            color: '#1773bc',
            fontSize: '2rem'
          }}>
            Confirm date change
          </Typography>
        </Box>
      </DialogTitle>
      
      <Divider />
      
      <DialogContent sx={{ padding: '16px 24px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="body1" sx={{ 
            fontSize: '1.4rem',
            lineHeight: 1.5,
            textAlign: 'center',
            color: '#333'
          }}>
            You are updating the project's SOW End Date. This change will automatically adjust the end dates of all associated employee allocations to align with the new SOW End Date.
          </Typography>
          
          <Box sx={{ 
            backgroundColor: '#f8f9fa', 
            padding: '12px', 
            borderRadius: '6px',
            border: '1px solid #e9ecef'
          }}>
            <Typography variant="body2" sx={{ 
              color: '#495057',
              marginBottom: '6px',
              fontWeight: 600,
              fontSize: '1.4rem'
            }}>
              Date Change Summary:
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Typography variant="body2" sx={{ color: '#333', fontSize: '1rem' }}>
                <strong>Previous End Date:</strong> {originalEndDate || 'Not set'}
              </Typography>
              <Typography variant="body2" sx={{ color: '#333', fontSize: '1rem' }}>
                <strong>New End Date:</strong> {newEndDate || 'Not set'}
              </Typography>
            </Box>
          </Box>
          
          <Typography variant="body2" sx={{ 
            fontSize: '1.05rem',
            textAlign: 'center',
            color: '#d32f2f',
            fontWeight: 500
          }}>
            Are you sure you want to proceed?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: '12px 24px 16px 24px', gap: 1, justifyContent: 'center' }}>
        <Button
          onClick={handleCancel}
          disabled={loading}
          variant="outlined"
          size="medium"
          sx={{
            borderRadius: '6px',
            color: '#666',
            borderColor: '#999',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              borderColor: '#666'
            },
            minWidth: '80px',
            textTransform: 'none'
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={loading}
          variant="contained"
          size="medium"
          sx={{
            borderRadius: '6px',
            backgroundColor: '#d32f2f',
            '&:hover': {
              backgroundColor: '#b71c1c'
            },
            minWidth: '90px',
            textTransform: 'none'
          }}
        >
          {loading ? (
            <>
              <div style={{
                backgroundColor: 'white',
                padding: '1px',
                marginRight: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img 
                  src={VeersaLoaderGif} 
                  alt="Loading..." 
                  style={{ width: '20px', height: '20px' }}
                />
              </div>
              Updating...
            </>
          ) : (
            'Confirm'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectEndDateConfirmationModal;
